module.exports = "/Public/build/ec96269fcd574853a6c560b6b584c6ba.png";


//////////////////
// WEBPACK FOOTER
// ./data/assets/markers/project-current.png
// module id = 154
// module chunks = 0 1